import en from 'date-format-parse/es/locale/en.js'

const lang = {
  formatLocale: en,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true
}

export default lang
